import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLike = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0459 7C16.4276 7 16.8057 7.07283 17.1601 7.21457C18.6985 7.82991 19.4467 9.57582 18.8314 11.1142L16.4314 17.1142C15.9758 18.2531 14.8726 19 13.6459 19H6C4.34315 19 3 17.6569 3 16V8.82843C3 8.03278 3.31607 7.26972 3.87868 6.70711L8.58579 2H9.46762C10.0114 2 10.5449 2.14777 11.0111 2.42752C12.4318 3.27997 12.8925 5.12275 12.0401 6.54349L11.7662 7H16.0459ZM5.29289 8.12132C5.10536 8.30886 5 8.56321 5 8.82843V16C5 16.5523 5.44772 17 6 17H13.6459C14.0548 17 14.4225 16.751 14.5744 16.3714L16.9744 10.3714C17.1795 9.85861 16.9301 9.27664 16.4173 9.07152C16.2992 9.02428 16.1732 9 16.0459 9H8.23381L10.3251 5.5145C10.6093 5.04092 10.4557 4.42666 9.98211 4.14251C9.8267 4.04926 9.64886 4 9.46762 4H9.41421L5.29289 8.12132Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLike);

export default ForwardRef;
